export const CONTACT_FORM_URL = 'https://readdy.ai/api/form/d9p0d80senbniolesnag';